<!-- <button class="info-tooltip"></button> -->
<div class="help-container" *ngIf="infoTooltip">
  <p class="help-content">{{ infoTooltip | translate }}</p>
  <button class="help-toggle">
    <img src="/assets/img/icons/positive-clear/help-legend.svg" />
  </button>
</div>
<app-widget-base [title]="first?.label">
  <div class="stats-wrapper">
    <p class="first stat" [class.has-icon]="first?.icon">
      <span class="reference" *ngIf="isMultiple">{{
        referenceLabel | translate
      }}</span>
      <span *ngIf="first?.icon" class="icon-container"
        ><img [src]="first?.icon" class="icon" alt="stat icon"
      /></span>
      <span class="value">{{ first?.value | hideZeroValues : '1.0-1' }}</span>
      <span class="suffix"> {{ first?.suffix | translate }} </span>
      <span
        *ngIf="first?.percent !== null"
        class="percent"
        [class.up]="first?.percent >= 0"
        [class.down]="first?.percent < 0"
      >
        {{ first?.percent >= 0 ? '+' : ''
        }}{{ first?.percent | hideZeroValues : '1.0-2' }}
        <span class="unit">%</span>
      </span>
    </p>
    <p class="stat compared-wrapper" *ngIf="isMultiple">
      <span class="compared">{{ comparedLabel | translate }}</span>
      <span class="value">{{
        first?.compValue | hideZeroValues : '1.0-1'
      }}</span>
      <span class="suffix"> {{ first?.suffix | translate }}</span>
    </p>
    <div
      *ngIf="hasDetails()"
      [ngClass]="'detail-' + details.length"
      class="details"
      [class.multiple]="isMultiple"
    >
      <div *ngFor="let det of details">
        <h4>{{ det?.label | translate }}</h4>
        <p class="reference" *ngIf="isMultiple">
          {{ referenceLabel | translate }}
        </p>
        <p>
          {{ det?.value | hideZeroValues : '1.0-1' }}
          <span *ngIf="det?.suffix" class="suffix">
            {{ det?.suffix | translate }}</span
          >
        </p>

        <div *ngIf="isMultiple">
          <p class="compared">{{ comparedLabel | translate }}</p>
          <p>
            {{ det?.compValue | hideZeroValues : '1.0-1' }}
            <span *ngIf="det?.suffix" class="suffix">
              {{ det?.suffix | translate }}</span
            >
          </p>
        </div>
      </div>
    </div>
  </div>
</app-widget-base>
